import { Sport } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useSportContext } from 'contexts/sport';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

export const useSeriesNav = () => {
  const { footballUserProfile } = useCurrentUserContext();
  const { sport } = useSportContext();

  const {
    flags: { enableSeriesOnboardingPack = false },
  } = useFeatureFlags();
  return (
    enableSeriesOnboardingPack &&
    sport === Sport.FOOTBALL &&
    !footballUserProfile?.proUnlocked
  );
};
